window.mcb.links = window.mcb.links || {};
window.mcb.links.globalNavigation = (function () {
    const _logger = window.mcb.utilities.createLogger('links.globalNavigation');

    const selectorContainer = '.link-collection-recursive';
    const attributeName = 'aria-expanded';
    const selectorTrigger = '.mcb-activator';
    const closeTrigger = '.link-collection-recursive-back-button';
    let lcrCounter = 0;

    const deactivateAll = function (container) {
        container.querySelectorAll('.mcb-activator,.mcb-activatable').forEach((el) => {
            el.setAttribute(attributeName, false);
        });
    };

    _logger.trace('init');
    document.querySelectorAll('.link-collection-recursive').forEach((lcr) => {
        lcrCounter++;
        let subCounter = 0;
        for (const lcrChild of lcr.children) {
            if (lcrChild.tagName === "UL") {
                for (var li of lcrChild.children) {
                    const a = li.querySelector('a');
                    if (a !== null && a.classList.contains('mcb-activator')) {
                        subCounter++;
                        a.setAttribute('data-activator-id', 'a-' + lcrCounter.toString() + '-' + subCounter.toString());
                    }
                }

                subCounter = 0;
            }
            else {
                subCounter++;
                lcrChild.setAttribute('data-activation-id', 'a-' + lcrCounter.toString() + '-' + subCounter.toString());
            }
        }
    });

    const hasActiveNode = function (container) {
        return container.querySelector('.mcb-activatable[aria-expanded="true"]') !== null;
    };

    const suppressTransition = function (container) {
        const header = container.closest('.navigation-header');
        if (!header) return;
        header.classList.add('mcb-nav--switching');
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                header.classList.remove('mcb-nav--switching');
            });
        });
    };

    _logger.trace('Registering Events');
    document.querySelectorAll(selectorTrigger).forEach((nav) => {
        nav.addEventListener('click', function (event) {
            event.preventDefault();

            _logger.trace('Activation', event);

            const trigger = event.target;
            const current = (trigger.getAttribute(attributeName) || false).toString();
            const inverse = current === "false";

            var container = event.target.closest(selectorContainer);
            if (container !== null) {
                // Suppress animation when switching between active nodes
                if (inverse === true && hasActiveNode(container)) {
                    suppressTransition(container);
                }

                deactivateAll(container);

                if (inverse === true) {
                    const identity = trigger.getAttribute('data-activator-id');
                    const target = container.querySelector('.mcb-activatable[data-activation-id="' + identity + '"]');
                    if (target !== null) {
                        target.setAttribute(attributeName, inverse);
                        trigger.setAttribute(attributeName, inverse);
                    }
                    else {
                        _logger.warn('No activation target found for identity', identity);
                    }
                }
            }
            else {
                _logger.warn('No activatable ancestor found', event.target);
            }

            _logger.trace('Toggled', trigger, inverse);
        });
    });

    document.querySelectorAll(closeTrigger).forEach((nav) => {
        nav.addEventListener('click', function (event) {
            event.preventDefault();

            _logger.trace('Deactivation', event);

            var container = event.target.closest(selectorContainer);
            if (container !== null) {
                deactivateAll(container);
            }
            else {
                _logger.warn('No deactivatable ancestor found', event.target);
            }
        });
    });

    document.querySelectorAll('.navigation-header').forEach((canvas) => {
        canvas.addEventListener('click', function (event) {
            event.stopPropagation();
        });
    });

    document.querySelectorAll('.navigation-overlay').forEach((canvas) => {
        canvas.addEventListener('click', function () {
            deactivateAll(document);
        });
    });
})();

window.mcb.links.globalNavigationMobile = (function () {
    const _logger = window.mcb.utilities.createLogger('links.globalNavigationMobile');

    const attributeName = 'aria-expanded';
    const menuElement = document.getElementById('mcb-page-header');
    const triggerElement = document.getElementById('mobileMenuToggle');

    if (menuElement === null || triggerElement === null) {
        _logger.trace('Mobile menu elements not present, skipping registration');
        return;
    }

    _logger.trace('Registering Events');
    triggerElement.addEventListener('click', function (event) {
        event.preventDefault();

        _logger.trace('Activation', event);

        const current = (menuElement.getAttribute(attributeName) || false).toString();
        const inverse = current === "false";
        menuElement.setAttribute(attributeName, inverse);
        triggerElement.setAttribute(attributeName, inverse);

        _logger.trace('Toggled', triggerElement, inverse);
    });
})();
